import React from 'react'

const SkipLinks: React.FC = () => {
  return (
    <div className="sr-only focus-within:not-sr-only">
      <a 
        href="#main-content" 
        className="absolute top-0 left-0 bg-blue-600 text-white px-4 py-2 z-50 focus:relative focus:z-50"
        onFocus={(e) => e.target.classList.remove('sr-only')}
        onBlur={(e) => e.target.classList.add('sr-only')}
      >
        Skip to main content
      </a>
      <a 
        href="#navigation" 
        className="absolute top-0 left-0 bg-blue-600 text-white px-4 py-2 z-50 focus:relative focus:z-50 ml-32"
        onFocus={(e) => e.target.classList.remove('sr-only')}
        onBlur={(e) => e.target.classList.add('sr-only')}
      >
        Skip to navigation
      </a>
      <a 
        href="#footer" 
        className="absolute top-0 left-0 bg-blue-600 text-white px-4 py-2 z-50 focus:relative focus:z-50 ml-64"
        onFocus={(e) => e.target.classList.remove('sr-only')}
        onBlur={(e) => e.target.classList.add('sr-only')}
      >
        Skip to footer
      </a>
    </div>
  )
}

export default SkipLinks
